import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ConsentBrandHeader = ({ logoUrl, practiceName, primaryColor, theme, pdfMode, addressLines }) => {
    const dividerEnabled = theme?.brandDividerEnabled !== false;
    const dividerColor = theme?.brandDividerColor || primaryColor || theme?.primaryColor || '#00AB55';
    const dividerWidth = theme?.brandDividerWidth || 2;

    return (
    <Box data-consent-brand-header data-pdf-block={pdfMode ? 'practice-branding' : undefined} sx={{
        textAlign: pdfMode ? 'left' : theme?.brandLogoAlignment || 'center',
        pb: pdfMode ? 1 : 3,
        mb: pdfMode ? 1.5 : 3,
        ...(pdfMode ? { breakInside: 'avoid', overflowWrap: 'anywhere' } : {}),
        ...(dividerEnabled ? { borderBottom: `${dividerWidth}px solid ${dividerColor}` } : {}),
    }}>
        {logoUrl && (
            <Box
                component="img"
                crossOrigin={pdfMode ? 'anonymous' : undefined}
                data-pdf-practice-logo={pdfMode || undefined}
                onError={pdfMode ? (event) => { event.currentTarget.style.display = 'none'; } : undefined}
                src={logoUrl}
                alt={practiceName || 'Practice Logo'}
                sx={{
                    height: pdfMode ? 40 : theme?.brandLogoHeight || 60,
                    maxWidth: '100%',
                    mb: pdfMode ? 0.5 : 1.5,
                    objectFit: 'contain',
                }}
            />
        )}
        {practiceName && (pdfMode || theme?.showPracticeName !== false) && (
            <Typography sx={{
                fontSize: pdfMode ? '16px' : theme?.practiceNameFontSize || '1.5rem',
                fontWeight: 700,
                color: theme?.headingColor || '#212B36',
                fontFamily: theme?.headingFontFamily || theme?.fontFamily || 'inherit',
            }}>
                {practiceName}
            </Typography>
        )}
        {pdfMode && addressLines.length > 0 && (
            <Typography component="div" sx={{ fontFamily: 'inherit', fontSize: '12px', lineHeight: 1.4, color: '#637381', mt: 0.5, overflowWrap: 'anywhere' }}>
                {addressLines.map((line, index) => <div key={`${index}-${line}`}>{line}</div>)}
            </Typography>
        )}
    </Box>
    );
};

ConsentBrandHeader.propTypes = {
    logoUrl: PropTypes.string,
    pdfMode: PropTypes.bool,
    addressLines: PropTypes.arrayOf(PropTypes.string),
    practiceName: PropTypes.string,
    primaryColor: PropTypes.string,
    theme: PropTypes.object,
};

ConsentBrandHeader.defaultProps = {
    logoUrl: '',
    pdfMode: false,
    addressLines: [],
    practiceName: '',
    primaryColor: '#00AB55',
    theme: null,
};

export default ConsentBrandHeader;
